module.exports = __webpack_public_path__ + "3de9418cbad0a1cdc1c01ad2a81f7762.MP3";